import { Event } from "../model/impl/Event";
import { EventType } from "../enum/EventType";

export class EventsFilter{
    public static filterEvent(event : Event, kitId : string|null) : boolean{
        //Se il kit non è settato significa che la connessione è boradcast quindi vengono messi in coda tutti gli eventi
        if(kitId===null){
            return true;
        }

        switch(event.type){
            case EventType.HIT_EVENT:
              if(event.kitId===kitId){
                return true;
              }
              break;
      
            case EventType.KIT_STATUS_EVENT:
              if(event.kitId===kitId){
                return false;
              }
              break;
      
            case EventType.MISSION_STATUS_EVENT:
              return false;
      
            case EventType.REVIVE_EVENT:
              if(event.kitId===kitId){
                return true;
              }
              break;
          }

        return false;
    }
}